import qs from 'qs';
import request from '@/utils/request';
/* 发送短信验证码 */
export function telCodeApi(data) {
  return request({
    url: '/send/sms',
    method: 'post',
    data: qs.stringify(data)
  })
}
/* 邮箱登录-注册 */
export function emailLoginApi(data) {
  return request({
    url: '/account/login/form/email',
    method: 'post',
    data: qs.stringify(data)
  })
}
/* 邮箱重置密码 */
export function emailPwdApi(data) {
  return request({
    url: '/account/reset/password/form/email',
    method: 'post',
    data: qs.stringify(data)
  })
}
/* 手机号登录-注册 */
export function telLoginApi(data) {
  return request({
    url: '/account/login/form/phone',
    method: 'post',
    data: qs.stringify(data)
  })
}
/* 发送邮件 */
export function emailCodeApi(data) {
  return request({
    url: '/send/email',
    method: 'post',
    data: qs.stringify(data)
  })
}
/* 验证邮件 */
export function bindAccountApi(params) {
  return request({
    url: '/account/bind',
    method: 'post',
    params
  })
}
/* 三方登录 */
export function otherLoginApi(oauthType, params) {
  return request({
    url: `/render/${oauthType}`,
    method: 'get',
    params
  })
}

/* 支付宝绑定 */
export function alipayBindApi() {
  return request({
    url: `/alipayBind`,
    method: 'get',
  })
}
